import { HexColorInput } from 'react-colorful';
import { defaultColours } from 'components/Reports/ui/ReportDesignButton';

interface UploadHubColourPickerProps {
  color: string;
  setColor: (color: string) => void;
}

const UploadHubColourPicker = ({ color, setColor }: UploadHubColourPickerProps) => (
  <div className='d-flex flex-wrap ' style={{ maxWidth: '252px' }}>
    {defaultColours.map((item: string) => {
      const isSelected = item.toLowerCase() === color?.toLowerCase();
      return (
        <button
          key={item}
          type='button'
          className='general-button specific-right-margin-6 specific-bottom-margin-6 rounded'
          style={{
            width: '30px',
            height: '30px',
            backgroundColor: item,
            border: isSelected
              ? '1px solid #00122B'
              : item === '#FFFFFF'
                ? '1px solid #E4E9ED'
                : '2px solid transparent',
          }}
          onClick={() => setColor(item)}
          aria-label={`Set color to ${item}`}
          aria-pressed={isSelected}
        />
      );
    })}
    <div className='d-flex color-picker-hex-color-input specific-right-margin-6'>
      <span className='text-main-blue-35 d-inline-block d-flex align-items-center justify-content-center'>
        <span>#</span>
      </span>
      <HexColorInput
        color={color}
        onChange={setColor}
        prefixed
        className='border rounded px-2 specific-y-padding-3 w-100'
        style={{ fontSize: '14px' }}
      />
    </div>
  </div>
);

export default UploadHubColourPicker;
